import React from 'react';
import StaffProfileTemplate, {
  ProfileSection,
  ProfileParagraphs,
  ProfileBullets,
  ProfilePublications,
  ProfileContactSection,
} from './StaffProfileTemplate';

const ShoulMoviProfile = () => {
  const person = {
    id: 'sholu-movi',
    name: 'Sholu Movi',
    honorific: 'Mr',
    title: 'Assistant Researcher',
    affiliation: 'The Highland Institute, Kohima, Nagaland',
    image: 'https://customer-assets.emergentagent.com/job_vegr-highland/artifacts/qqvd6y3i_Sholu%20Movi.jpg',
    email: 'sholu@highlandinstitute.org',
    category: 'Research Staff',
    testid: 'sholu-movi-profile',
  };

  return (
    <StaffProfileTemplate person={person}>
      <ProfileSection title="Intellectual Biography">
        <ProfileParagraphs
          items={[
            'Sholu Movi is an Assistant Researcher at The Highland Institute, Kohima, Nagaland. His work focuses on climate change, Indigenous knowledge, and local perspectives on environmental and social change in Nagaland. Grounded in ethnographic research and qualitative interviews, his work engages closely with communities to document lived experiences, local knowledge systems, and changing relationships between people, land, environment, and livelihoods.',
            'His research is particularly concerned with how communities understand and respond to climate change through everyday experience, agricultural practices, oral knowledge, and place-based observations. Through field-based research, he contributes to documenting how environmental change is perceived, narrated, and interpreted at the community level, especially in relation to land use, farming, weather patterns, and livelihood change.',
            'Sholu recently contributed significantly to the Myanmar, Climate Actions, Conflict and Peacebuilding Project (MyCClimate), which examined climate change perspectives and community experiences in Nagaland. As part of the project, he supported ethnographic documentation, qualitative interviews, and community-based research exploring how local people experience environmental and social transformation. His work contributed to documenting local perspectives and Indigenous knowledge in discussions of climate change.',
            "Sholu's broader areas of interest include Indigenous knowledge systems, environmental change, community perspectives, ethnographic methods, and qualitative research. His work reflects a commitment to understanding climate change not only as an environmental issue, but also as a lived social experience shaped by local histories, livelihoods, and community relations.",
          ]}
        />
      </ProfileSection>

      <ProfileSection title="Collaborative and Public-Facing Projects">
        <ProfileParagraphs
          items={[
            <>
              Beyond his research work, Sholu has also contributed to public-facing cultural initiatives at The Highland Institute. He was involved in the documentary <em>Healing Hands: Tale of an Angami Healer</em>, produced in collaboration with the School of Film, Media and Creative Arts, Rashtreeya Vidyalaya University. The documentary, which explored Indigenous healing traditions among the Angami community, especially the relationship between herbal knowledge, spirituality, faith, and the natural world, was shown at the Berlin International Film Festival in July 2025. His contribution reflected his broader interest in Indigenous knowledge, community documentation, and collaborative cultural work.
            </>,
            'In 2023–24, Sholu was a Research Assistant on a University of Göttingen study examining changing food preparation and consumption patterns in Nagaland at household, market, and village levels. The project explored transformations in food systems, dietary practices, and socio-economic life across Naga contexts. His involvement in this work connects with his broader interests in food systems, environmental change, livelihoods, and community knowledge in Nagaland. In 2024, he worked as a Research Assistant on a Firebird Foundation-supported project documenting oral traditions, everyday practices, and beliefs among the Tenyimia Nagas.',
            'He is currently assisting with the development of The Highland Institute Wiki, a collaborative knowledge platform for projects, communities, languages, material culture, environmental knowledge, archives, and related themes. Alongside this work, he provides technical support for the Institute\'s computer systems and administrative support for the School of Advanced Studies.',
          ]}
        />
      </ProfileSection>

      <ProfileSection title="Research Foci & Areas of Work">
        <ProfileBullets
          items={[
            'Climate change',
            'Indigenous knowledge',
            'Ethnographic research',
            'Community perspectives',
            'Environmental change in Nagaland',
            'Interviews and qualitative research methods',
            'Local experiences of environmental and social change',
            'Community-based documentation',
          ]}
        />
      </ProfileSection>

      <ProfileSection title="Education">
        <ProfileBullets items={['M.Sc. Zoology', 'Diploma in Computer Application']} />
      </ProfileSection>

      <ProfileSection title="Professional Experience">
        <ProfileBullets items={['Sales Executive, Penthrill']} />
      </ProfileSection>

      <ProfileSection title="Publications, Media & Public Scholarship">
        <ProfilePublications
          items={[
            {
              year: '2024',
              citation: (
                <>
                  'Everyday Lives of Naga Women' in <em>Highlander</em>, Vol. 3, Issue 2, pp. 134–141.
                </>
              ),
              url: 'https://doi.org/10.5281/zenodo.11002325',
            },
          ]}
        />
        <h3 className="font-semibold text-stone-900 mt-8 mb-3 not-prose">Selected Blogs</h3>
        <ul className="space-y-2 not-prose">
          <li className="flex items-start gap-3 text-stone-700"><span className="text-green-600 mt-1">•</span><span>Exploring Eden</span></li>
          <li className="flex items-start gap-3 text-stone-700"><span className="text-green-600 mt-1">•</span><span>Cross-border bonds</span></li>
        </ul>
      </ProfileSection>

      <ProfileContactSection
        email={person.email}
        role="Assistant Researcher, The Highland Institute"
        testidPrefix="sholu"
        scholarlyProfiles={[
          { label: 'ORCID', url: 'https://orcid.org/0009-0007-1193-1248', testid: 'sholu-orcid-link' },
          { label: 'LinkedIn', url: 'https://in.linkedin.com/in/sholu-movi-1000b6401', testid: 'sholu-linkedin-link' },
        ]}
      />
    </StaffProfileTemplate>
  );
};

export default ShoulMoviProfile;
